import { connect } from 'react-redux';
import { showMobileDeviationSharePopup } from '../../../Modals/redux/actionCreators';
var mapDispatchToProps = {
    onClick: showMobileDeviationSharePopup,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=ShareButton.container.js.map